<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div style="width: 100%" v-loading="loading">
        <ServiceInfo></ServiceInfo>
        <div class="col-md-10 col-sm-12 m-auto jipvio-rad">
          <!-- =================================================매물 위치 정보 -->
          <div class="m-auto">
            <span class="propInfoTitle">1. 매물 위치 정보</span>
            <card id="agt_step3_propLocInfoCard" tabindex="0" class="mt-15">
              <div slot="header">
                <h3 class="card-title" align="center">매물 위치 정보</h3>
              </div>

              <div class="row ml-0 mr-0">
                <div class="col-lg-8 fl pl-0">
                  <div class="mb-30">
                    <h6 class="mb-0">
                      <i class="fas fa-exclamation-circle"></i>
                      건축물대장 상의 주소를 입력해주세요. 건축물대장에서
                      자동으로 매물 정보를 불러옵니다.
                    </h6>
                    <h6>
                      <i class="fas fa-exclamation-circle"></i>
                      도로명, 건물명, 지번에 대해 통합검색이 가능합니다.
                    </h6>
                  </div>

                  <!-- 주소 -->
                  <div class="row m-row">
                    <label class="col-lg-2 col-md-12 col-form-label px-0"
                      >주소</label
                    >
                    <div class="col-lg-10 col-md-12 col-sm-12 px-0">
                      <div class="fl r-noradius btn-pct-m" style="width: 90%">
                        <ValidationProvider
                          ref="propertyRAddrVal"
                          rules="required"
                          v-slot="{ failed }"
                        >
                          <fg-input
                            type="text"
                            :error="failed ? '매물 주소를 입력해주세요' : null"
                            placeholder="주소 (required)"
                            v-model="propertyRAddr"
                            @keyup.enter.native="addressPop"
                          >
                          </fg-input>
                        </ValidationProvider>
                      </div>

                      <div class="fl btn-pct-b" style="width: 10%">
                        <el-button
                          class="el-btn-height jip-cont-btn l-noradius"
                          icon="el-icon-search"
                          @click="addressPop"
                        ></el-button>
                      </div>
                    </div>
                  </div>

                  <!--상세주소 -->
                  <div class="row m-row">
                    <label class="col-lg-2 col-md-12 col-form-label px-0"
                      >상세주소</label
                    >
                    <div class="col-lg-10 col-md-12 col-sm-12 px-0">
                      <div class="col-md-6 fl pb-10 px-0">
                        <div class="fullWidth">
                          <!-- <label class="fl col-form-label" style="width:15%">동</label> -->
                          <el-select
                            class="addrSelectWidth"
                            style="width: 100%"
                            v-model="selectedDongIdx"
                            placeholder="동"
                            @change="bringHoFlr()"
                            :disabled="dongDisable"
                          >
                            <el-option
                              v-for="(bdl, i) in bdList"
                              :key="i"
                              :label="changeDong(bdl.dongNm)"
                              :value="i"
                            ></el-option>
                          </el-select>
                        </div>
                      </div>

                      <div class="col-md-6 fl pb-10 px-0">
                        <div class="fullWidth">
                          <!-- <label class="fl col-form-label" style="width:15%">호</label> -->
                          <el-select
                            class="addrSelectWidth"
                            style="width: 100%"
                            v-model="selectedHo"
                            placeholder="호"
                            @change="
                              getFullRAddress();
                              getFullJAddress();
                            "
                            :disabled="hoDisable"
                          >
                            <el-option
                              v-for="(ho, i) in hoList"
                              :key="i"
                              :label="changeHo(ho)"
                              :value="ho"
                            ></el-option>
                          </el-select>
                        </div>
                      </div>
                      <div class="col-12 fl pb-10 px-0">
                        <h6 class="mb-0">
                          <i class="fas fa-exclamation-circle"></i>
                          건축물대장에 동, 호수가 없는 경우: 층 선택 후 임대할
                          면적을 입력합니다.
                        </h6>
                      </div>
                      <div class="col-md-6 fl pb-0 px-0">
                        <div class="fullWidth jipvio-bg-white">
                          <!-- .form-control[readonly]색 white로 바꿈 -->
                          <!-- <label class="fl col-form-label" style="width:15%">층</label> -->
                          <ValidationProvider
                            ref="selectedFlrVal"
                            rules="required"
                          >
                            <fg-input
                              type="text"
                              class="fl addrSelectWidth"
                              style="width: 100%"
                            >
                              <el-select
                                placeholder="층"
                                style="width: 100%"
                                v-model="selectedFlr"
                                @change="
                                  getFullRAddress();
                                  getFullJAddress();
                                "
                              >
                                <el-option
                                  v-for="flrl in flrList"
                                  :key="flrl.index"
                                  :label="changeFlr(flrl)"
                                  :value="flrl"
                                ></el-option>
                              </el-select>
                            </fg-input>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="fl col-12 pb-10 px-0" v-if="flrCheckShow">
                        <div class="fl col-xl-3 px-0">
                          <el-checkbox
                            label="전체"
                            class="fl col-6 m-0 col-form-label pl-0"
                            v-model="allFloor"
                            :disabled="partFloor"
                          ></el-checkbox>

                          <el-checkbox
                            label="일부"
                            class="fl col-6 px-0 col-form-label"
                            v-model="partFloor"
                            :disabled="allFloor"
                            @change="partArea = null"
                          ></el-checkbox>
                        </div>
                        <div
                          class="fl col-xl-6 px-0"
                          v-show="partFloor === true"
                        >
                          <el-input
                            class="fl"
                            style="width: 48%"
                            v-model="partArea"
                          >
                            <template slot="append">m²</template>
                          </el-input>
                          <!-- <label class="fl col-form-label" style="width:">m²</label> -->
                          <el-input
                            class="fr"
                            style="width: 48%"
                            v-model="hoTitle"
                          >
                            <template slot="append">명칭</template>
                          </el-input>
                          <!-- <label class="fl col-form-label" style="">명칭</label> -->
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 주소 정보 -->
                  <div class="row m-row pb-10">
                    <label class="col-lg-2 col-md-12 col-form-label px-0"
                      >주소정보</label
                    >
                    <div class="col-lg-10 col-md-12 col-sm-12 px-0">
                      <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="Please input"
                        v-model="fullAddr"
                      ></el-input>
                    </div>
                  </div>

                  <div class="fl btn-pct-b" style="width: 25%">
                    <el-button
                      class="el-btn-height jip-cont-btn"
                      @click="getExtraInfo"
                      >정보 불러오기</el-button
                    >
                  </div>
                </div>

                <!-- map -->
                <div class="col-lg-4 fl pl-0">
                  <div class="pptInquiry_map_wrap">
                    <div
                      class="pptInquiry_map_inner"
                      id="AgtStep3Map"
                      align="right"
                    ></div>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <!-- =================================================건축물 정보 -->
          <div class="mt-10">
            <span class="propInfoTitle">2. 매물 정보</span>
            <card class="mt-15">
              <div slot="header">
                <h3 class="card-title">건축물 정보</h3>
              </div>
              <div class="row m-row">
                <!-- 용도지역 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">용도지역</label>
                  <div class="fl col-8 pl-0">
                    <el-input
                      v-model="this.brdListForInput"
                      disabled
                    ></el-input>
                  </div>
                </div>

                <!--대지면적 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">대지면적</label>
                  <div class="fl col-8 pl-0">
                    <el-input v-model="platArea" disabled>
                      <template slot="append">m²</template>
                    </el-input>
                  </div>
                </div>

                <!--연면적 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">연면적</label>
                  <div class="fl col-8 pl-0">
                    <el-input v-model="totArea" disabled>
                      <template slot="append">m²</template>
                    </el-input>
                  </div>
                </div>

                <!-- 건축물 용도 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">
                    건축물용도
                    <el-tooltip effect="dark" placement="top-start">
                      <div slot="content">
                        건축물 주용도는 건축물대장, 정부와 공공기관이 공개한
                        <br />자료를 바탕으로 자동 입력됩니다. <br />(자료의
                        기준시점에 따라 일치하지 않을 수 있습니다.)
                        <br />집비오의 매물유형은 주용도에 따라 아파트, 빌라,
                        주택 <br />으로 카테고리가 자동 분류됩니다.
                        <br />
                        <br />
                        <el-table :data="clsfData" size="mini" border>
                          <el-table-column
                            prop="clsfByJv"
                            label="집비오 분류"
                            width="100"
                          ></el-table-column>
                          <el-table-column
                            prop="purpsDetail"
                            label="건축물 세부용도"
                            width="150"
                          ></el-table-column>
                          <el-table-column
                            prop="purps"
                            label="건출물용도(건축법)"
                            width="150"
                          ></el-table-column>
                        </el-table>
                      </div>
                      <i
                        class="fas fa-exclamation-circle"
                        style="color: red"
                      ></i>
                    </el-tooltip>
                  </label>
                  <div class="fl col-8 pl-0">
                    <el-input v-model="purps" disabled></el-input>
                  </div>
                </div>
                <!-- 건축물 세부용도 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">세부용도</label>
                  <div class="fl col-8 pl-0">
                    <el-input v-model="purpsDetail" disabled></el-input>
                  </div>
                </div>

                <!--총세대수 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">총 세대수</label>
                  <div class="fl col-8 pl-0">
                    <el-input v-model="hhldCnt" disabled>
                      <template slot="append">세대</template>
                    </el-input>
                  </div>
                </div>

                <!--명칭 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0">명칭</label>
                  <div class="fl col-8 pl-0">
                    <el-input v-model="locationInfo.bdNm" disabled> </el-input>
                  </div>
                </div>

                <!--사용승인 일자 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0"
                    >사용승인 일자</label
                  >

                  <div class="fl col-8 pl-0">
                    <el-input v-model="useAprDay" disabled></el-input>
                  </div>
                </div>

                <!-- 총 주차대수 -->
                <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
                  <label class="fl col-4 col-form-label px-0"
                    >총 주차대수</label
                  >
                  <div class="fl col-8 pl-0">
                    <el-input v-model="totPkngCnt" disabled>
                      <template slot="append">대</template>
                    </el-input>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <!--=================================================거래 정보 -->
          <div class="">
            <card id="agt_step3_contrInfoCard" tabindex="0" class="mt-15">
              <div slot="header">
                <h3 class="card-title">거래 정보</h3>
              </div>
              <div class="row m-row">
                <!-- 거래유형 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">거래유형</label>
                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="ctrTypeVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-radio-group
                          v-model="paymentType"
                          @change="monthlyPay = null"
                        >
                          <el-radio
                            class="mr-0 m-ml-0"
                            v-for="opt in selects.PTT"
                            :key="opt.value"
                            :label="opt.label"
                            border
                          ></el-radio>
                        </el-radio-group>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!--보증금 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">보증금</label>
                  <div class="fl col-9 px-0 mb-10">
                    <ValidationProvider
                      ref="depositVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input :error="failed ? 'value is required' : null">
                        <el-input v-model="deposit">
                          <template slot="append">만원</template>
                        </el-input>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!--월세 -->
                <div
                  class="fl col-lg-6 px-0 mb-10"
                  v-if="selects.PTTMap[paymentType] === 'MP'"
                >
                  <label class="fl col-3 col-form-label px-0">월세</label>
                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="monthlyPayVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input :error="failed ? 'value is required' : null">
                        <el-input v-model="monthlyPay">
                          <template slot="append">만원</template>
                        </el-input>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!-- 입주 가능일 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0"
                    >입주 가능일</label
                  >
                  <div class="fl col-9 pl-0">
                    <div class="fl mr-10">
                      <ValidationProvider
                        ref="possibleMoveDateVal"
                        rules="required"
                        v-slot="{ failed }"
                      >
                        <fg-input
                          v-show="!imdMove"
                          :error="failed ? '필수 입력 항목입니다!' : null"
                        >
                          <el-date-picker
                            v-model="possibleMoveDate"
                            type="date"
                            placeholder="날짜선택"
                          ></el-date-picker>
                        </fg-input>
                      </ValidationProvider>
                    </div>
                    <el-checkbox
                      v-show="
                        possibleMoveDate == null ||
                        possibleMoveDate == '0000-00-00'
                      "
                      v-model="imdMove"
                      class="el-checkbox fl px-0 col-form-label"
                      label="즉시입주"
                      @change="delPMD()"
                    ></el-checkbox>
                    <label
                      class="fl pr-0 col-form-label"
                      v-show="
                        possibleMoveDate != null &&
                        possibleMoveDate != '0000-00-00'
                      "
                    >
                      이후 입주협의
                    </label>
                  </div>
                </div>

                <!--전세자금 대출 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0"
                    >전세자금 대출</label
                  >

                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="loanYnVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-radio-group v-model="loanYn">
                          <el-radio class="mr-0" label="1" border
                            >가능</el-radio
                          >
                          <el-radio class="m-ml-0" label="0" border
                            >불가능</el-radio
                          >
                        </el-radio-group>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <!--================================================= 상세 정보 -->
          <div class="">
            <card id="agt_step3_detailInfoCard" tabindex="0" class="mt-15">
              <div slot="header">
                <h3 class="card-title">상세 정보</h3>
              </div>
              <div class="row m-row">
                <!-- 공급면적 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">공급면적</label>
                  <div class="fl col-9 mb-10 pl-0">
                    <el-input
                      class="fl"
                      v-model="finalProvArea"
                      disabled
                      style="width: 42%"
                    >
                      <template slot="append">m²</template>
                    </el-input>
                    <i
                      class="fl fas fa-sync-alt AreaIcon m-auto"
                      style="width: 16%; text-align: center"
                    ></i>
                    <el-input
                      class="fr"
                      v-model="supplyAreaP"
                      disabled
                      style="width: 42%"
                    >
                      <template slot="append">평</template>
                    </el-input>
                  </div>
                </div>

                <!--전용면적 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">전용면적</label>

                  <div class="fl col-9 mb-10 pl-0">
                    <el-input
                      style="width: 42%"
                      class="fl"
                      v-model="finalUseArea"
                      disabled
                    >
                      <template slot="append">m²</template>
                    </el-input>
                    <i
                      class="fl fas fa-sync-alt AreaIcon"
                      style="width: 16%; text-align: center"
                    ></i>
                    <el-input
                      class="fr"
                      style="width: 42%"
                      v-model="useAreaP"
                      disabled
                    >
                      <template slot="append">평</template>
                    </el-input>
                  </div>
                </div>

                <!--해당 층/ 총 층 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0"
                    >해당 층/총 층</label
                  >
                  <div class="fl col-9 pl-0 mb-10">
                    <el-input
                      class="fl"
                      v-model="modifiedFlr"
                      disabled
                      style="width: 42%"
                    >
                      <template slot="append">층</template>
                    </el-input>

                    <font
                      class="fl"
                      size="5px"
                      style="width: 16%; text-align: center"
                      >/</font
                    >
                    <el-input
                      class="fr"
                      style="width: 42%"
                      v-model="totFlrCnt"
                      disabled
                    >
                      <template slot="append">층</template>
                    </el-input>
                  </div>
                </div>

                <!-- 방 수 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">방 수</label>
                  <div class="fl col-5 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="TNORoomsVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          v-model="TNORooms"
                          placeholder="방 수"
                          @change="TNORoomsDirectWrite()"
                        >
                          <el-option label="1개" value="1"></el-option>
                          <el-option label="2개" value="2"></el-option>
                          <el-option label="3개" value="3"></el-option>
                          <el-option label="4개" value="4"></el-option>
                          <el-option label="직접입력" value="null"></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div class="fl TNORooms_wdth" v-if="TNORoomsDirect">
                    <el-input v-model="TNORooms"
                      ><template slot="append">개</template></el-input
                    >
                  </div>
                </div>

                <!--욕실 수 -->

                <div class="fl col-lg-6 px-0">
                  <label class="fl col-3 col-form-label px-0">욕실 수</label>
                  <div class="fl col-5 pl-0 mb-10 jipvio-bg-white">
                    <ValidationProvider
                      ref="TNOBathRoomsVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          v-model="TNOBathRooms"
                          placeholder="욕실 수"
                          @change="TNOBathRoomsDirectWrite()"
                        >
                          <el-option label="1개" value="1"></el-option>
                          <el-option label="2개" value="2"></el-option>
                          <el-option label="3개" value="3"></el-option>
                          <el-option label="4개" value="4"></el-option>
                          <el-option label="직접입력" value="null"></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div class="fl TNORooms_wdth" v-if="TNOBathRoomsDirect">
                    <el-input v-model="TNOBathRooms"
                      ><template slot="append">개</template></el-input
                    >
                  </div>
                </div>

                <!--승강기-->
                <div class="fl col-lg-6 px-0">
                  <label class="fl col-3 col-form-label px-0">승강기</label>

                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="eleYnVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-radio-group v-model="eleYn">
                          <el-radio class="mr-0" label="1" border
                            >있음</el-radio
                          >
                          <el-radio class="m-ml-0" label="0" border
                            >없음</el-radio
                          >
                        </el-radio-group>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!-- 난방방식 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">난방방식</label>
                  <div class="fl col-9 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="heatingTypeVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select v-model="heatingType" placeholder="난방방식">
                          <el-option
                            v-for="opt in selects.HTT"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!--난방연료 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">난방연료</label>
                  <div class="fl col-9 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="heatingFuelVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select v-model="heatingFuel" placeholder="난방연료">
                          <el-option
                            v-for="opt in selects.HFT"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!--현관구조 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">현관구조</label>

                  <div class="fl col-9 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="entStructureVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          v-model="entStructure"
                          placeholder="현관구조"
                        >
                          <el-option
                            v-for="opt in selects.ETT"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!--방향 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">
                    방향
                    <el-tooltip effect="dark" placement="top-start">
                      <div slot="content">
                        &lt;방향기준&gt;
                        <br />주거용: 거실, 안방 등 주실 기준 <br />그 밖의
                        건물: 주 출입구 기준
                      </div>
                      <i
                        class="fas fa-exclamation-circle"
                        style="color: red"
                      ></i>
                    </el-tooltip>
                  </label>

                  <div class="fl col-3 px-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="directionStdVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select v-model="directionStd" placeholder="기준">
                          <el-option
                            v-for="opt in selects.DST"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                  <div class="fl col-3 pr-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="directionVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select v-model="direction" placeholder="방향">
                          <el-option
                            v-for="opt in selects.DRT"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!-- 베란다/발코니 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0"
                    >베란다/발코니</label
                  >
                  <div class="fl col-9 pl-0">
                    <el-checkbox
                      v-model="verandaYn"
                      label="베란다"
                      border
                      class="ml-0 mr-0"
                    ></el-checkbox>
                    <el-checkbox
                      class="m-ml-0"
                      v-model="balconyYn"
                      label="발코니"
                      border
                    ></el-checkbox>
                  </div>
                </div>

                <!--주차가능대수 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0"
                    >주차가능대수</label
                  >

                  <div class="fl col-9 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="parkingYnVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select v-model="parkingYn" placeholder="주차">
                          <el-option label="가능" value="1"></el-option>
                          <el-option label="불가능" value="0"></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>

                  <div
                    v-if="Number(parkingYn) === 1"
                    class="col-sm-6 row m-row px-0"
                  >
                    <label class="fr col-3 pl-0 pr-10 col-form-label"
                      >가구당</label
                    >
                    <ValidationProvider
                      ref="pknPerFmlyVal"
                      rules="required"
                      v-slot="{ failed }"
                      class="fr col-9 px-0"
                    >
                      <fg-input
                        :error="
                          failed ? '가구 당 주차대수를 입력해주세요.' : null
                        "
                        class="fl"
                      >
                        <el-input v-model="PknPerFmly" type="number"
                          ><template slot="append">대</template>
                        </el-input>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>
                <!-- 관리비-->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">관리비</label>
                  <div class="fl col-9 maintenanceFee pl-0">
                    <ValidationProvider
                      ref="maintenanceFeeVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        type="number"
                        class="fl px-0 col-7"
                        :error="failed ? '필수 입력 항목입니다!' : null"
                        v-model="maintenanceFee"
                        label="만원"
                      ></fg-input>
                    </ValidationProvider>
                    <el-select
                      class="fr col-5 px-0"
                      v-model="maintenList"
                      placeholder="관리비항목"
                      multiple
                    >
                      <el-option
                        v-for="opt in selects.MTN"
                        :key="opt.value"
                        :label="opt.label"
                        :value="opt.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <!--사용료 -->
                <div class="fl col-lg-6 px-0 mb-10 jipvio-bg-white">
                  <label class="fl col-3 col-form-label px-0">사용료</label>
                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="useFeeYnVal"
                      rules="required"
                      v-slot="{ failed }"
                      class="fl mr-10"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-radio-group v-model="useFeeYn">
                          <el-radio class="ml-0 mr-0" label="1" border
                            >있음</el-radio
                          >
                          <el-radio
                            class="m-ml-0"
                            label="0"
                            border
                            @change="useFeeList = []"
                            >없음</el-radio
                          >
                        </el-radio-group>
                      </fg-input>
                    </ValidationProvider>
                    <!-- <el-input class="fl" style="width:60px" v-model="useFee"></el-input> -->

                    <div v-if="Number(useFeeYn) === 1">
                      <ValidationProvider
                        ref="useFeeListSelectVal"
                        rules="required"
                        v-slot="{ failed }"
                        class="fl mr-10"
                      >
                        <fg-input
                          :error="failed ? '필수 입력 항목입니다!' : null"
                        >
                          <el-select
                            v-model="useFeeList"
                            placeholder="사용료항목"
                            multiple
                            class="fl"
                          >
                            <el-option
                              v-for="opt in selects.UUF"
                              :key="opt.value"
                              :label="opt.label"
                              :value="opt.value"
                            ></el-option>
                          </el-select>
                        </fg-input>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <!--=================================================부가 정보 -->
          <div class="">
            <card id="agt_step3_extraInfoCard" tabindex="0" class="mt-15">
              <div slot="header">
                <h3 class="card-title">부가 정보</h3>
              </div>
              <div class="row m-row">
                <!-- 옵션 -->
                <div class="fl col-lg-6 px-0 mb-10 jipvio-bg-white">
                  <label class="fl col-3 col-form-label px-0">옵션</label>
                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="optionYnVal"
                      rules="required"
                      v-slot="{ failed }"
                      class="fl mr-10"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-radio-group v-model="optionYn">
                          <el-radio class="ml-0 mr-0" label="1" border
                            >있음</el-radio
                          >
                          <el-radio
                            class="m-ml-0"
                            label="0"
                            border
                            @change="optionList = []"
                            >없음</el-radio
                          >
                        </el-radio-group>
                      </fg-input>
                    </ValidationProvider>

                    <div v-if="Number(optionYn) === 1">
                      <ValidationProvider
                        ref="optionListSelectVal"
                        rules="required"
                        v-slot="{ failed }"
                        class="fl px-0 col-md-7"
                      >
                        <fg-input
                          :error="failed ? '필수 입력 항목입니다!' : null"
                        >
                          <el-select
                            v-model="optionList"
                            multiple
                            placeholder="옵션"
                            class="fl ft-18"
                          >
                            <el-option
                              v-for="opt in selects.BIO"
                              :key="opt.value"
                              :label="opt.label"
                              :value="opt.value"
                            ></el-option>
                          </el-select>
                        </fg-input>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <!--보안시설 -->
                <div class="fl col-lg-6 px-0 mb-10 jipvio-bg-white">
                  <label class="fl col-3 col-form-label px-0">보안시설</label>
                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="securityYnVal"
                      rules="required"
                      v-slot="{ failed }"
                      class="fl mr-10"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-radio-group v-model="securityYn">
                          <el-radio class="mr-0" label="1" border
                            >있음</el-radio
                          >
                          <el-radio
                            class="m-ml-0"
                            label="0"
                            border
                            @change="securityList = []"
                            >없음</el-radio
                          >
                        </el-radio-group>
                      </fg-input>
                    </ValidationProvider>

                    <!--   class="vali_no_bgcolor" -->
                    <div v-if="Number(securityYn) === 1">
                      <ValidationProvider
                        ref="securityListSelectVal"
                        rules="required"
                        v-slot="{ failed }"
                        class="fl px-0 col-md-7"
                      >
                        <fg-input
                          :error="failed ? '필수 입력 항목입니다!' : null"
                        >
                          <el-select
                            v-show="Number(securityYn) === 1"
                            v-model="securityList"
                            placeholder="보안시설"
                            multiple
                            class="fl ft-18"
                          >
                            <el-option
                              v-for="opt in selects.SCF"
                              :key="opt.value"
                              :label="opt.label"
                              :value="opt.value"
                            ></el-option>
                          </el-select>
                        </fg-input>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <!--반려동물-->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0">반려동물</label>
                  <div class="fl col-9 pl-0">
                    <ValidationProvider
                      ref="petYnVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-radio-group v-model="petYn">
                          <el-radio class="mr-0" label="1" border
                            >가능</el-radio
                          >
                          <el-radio class="m-ml-0" label="0" border
                            >불가능
                          </el-radio>
                        </el-radio-group>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!-- 방문 가능 요일 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0"
                    >방문 가능 요일</label
                  >
                  <div class="fl col-9 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="possibleVisitDaysVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          v-model="possibleVisitDays"
                          multiple
                          placeholder="방문 가능 요일"
                        >
                          <el-option
                            v-for="opt in selects.VPD"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>

                <!--방문 가능 시간 -->
                <div class="fl col-lg-6 px-0 mb-10">
                  <label class="fl col-3 col-form-label px-0"
                    >방문 가능 시간</label
                  >

                  <div class="fl col-9 pl-0 jipvio-bg-white">
                    <ValidationProvider
                      ref="possibleVisitTimesVal"
                      rules="required"
                      v-slot="{ failed }"
                    >
                      <fg-input
                        :error="failed ? '필수 입력 항목입니다!' : null"
                      >
                        <el-select
                          v-model="possibleVisitTimes"
                          multiple
                          placeholder="방문 가능 시간"
                        >
                          <el-option
                            v-for="opt in selects.VPT"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                          ></el-option>
                        </el-select>
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <!--================================================추가 설명 -->
          <div class="">
            <card class="mt-15">
              <div slot="header">
                <h3 class="card-title">추가 설명</h3>
              </div>
              <el-input
                v-model="extrExpl"
                type="textarea"
                :rows="4"
                placeholder="매물에 대한 추가 설명을 작성해주세요."
              ></el-input>
            </card>
          </div>

          <!-- ================================================추가 정보 동의 -->
          <div class="">
            <card class="mt-15">
              <div slot="header">
                <h3 class="card-title">추가 정보 동의</h3>
              </div>
              <div class="row m-row">
                <div class="fl col-lg-6">
                  <h5>
                    * 공인중개사법 제18조의2(중개대상물의 표시·광고) 개정안에
                    의거하여 의뢰인이 원치 않으실 경우, 다음과 같이 공개할
                    정보를 선택하실 수 있습니다.
                  </h5>
                  <ul class="pptInquiry_addData_Ul">
                    <li>단독주택의 경우 지번을 읍․면․동․리까지 표시 가능</li>
                    <li>공동주택의 경우 층을 저중고 로 대체 가능</li>
                  </ul>
                </div>
                <div class="fl col-lg-6 jipvio-bg-color5">
                  <h4 class="jipvio-text-center mt-10">
                    &lt;상세주소 표시·광고 여부 선택&gt;
                  </h4>
                  <div>
                    <div class="fl col-md-6">
                      <h5>1. 단독주택일 경우</h5>
                      <el-checkbox
                        v-model="oneHouseAgr"
                        label="읍,면,동,리 까지만 표시"
                      ></el-checkbox>
                    </div>
                    <div class="fl col-md-6">
                      <h5>2. 공동주택일 경우</h5>
                      <el-checkbox
                        v-model="shareHouseAgr"
                        label="층을 저중고로 표시"
                      ></el-checkbox>
                    </div>
                    <h6 class="jipvio-text-left pl-15 pt-10 pb-10 cl-bth">
                      위에 사항을 선택하지 않을 경우, 단독주택: 지번 포함 표시 /
                      단독주택 외: 지번과 동, 층수를 포함 표시 합니다.
                    </h6>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <!-- ============================================파일 업로드 -->

          <div class="jvo-upload">
            <card id="agt_step3_GImgUpl" tabindex="0" class="mt-15">
              <div slot="header">
                <h3 class="card-title">사진 등록</h3>
                <ul>
                  <li>
                    jpg, png, jpeg 등의 이미지 확장자 파일로 최소 2장 이상
                    등록합니다.
                  </li>
                  <li>
                    당 중개물과 관련된 실 사진만 첨부하시길 바랍니다. (그 외
                    관계없는 이미지는 삭제될 수 있습니다.)
                  </li>
                  <li>
                    첨부한 사진이 많거나 용량이 클 경우 업로드 시간이 다소
                    지연될 수 있습니다.
                  </li>
                </ul>
              </div>
              <div class="col-12 px-0">
                <el-upload
                  class="upload-demo col-12 px-0 text-center"
                  drag
                  :limit="3"
                  :auto-upload="false"
                  action="#"
                  :on-change="G_UploadChange"
                  :on-remove="G_RemoveFile"
                  :on-exceed="exceedFileLimit"
                  :file-list="G_Img_File.fileList"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    파일을 여기로 끌어 놓으세요. 혹은 <em>클릭해주세요.</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">
                    사이즈 500kb 미만의 jpg/png 파일로 제한
                  </div>
                </el-upload>
              </div>
            </card>
          </div>

          <!-- ============================================VR 업로드 -->

          <div class="jvo-upload">
            <card id="agt_step3_VrImgUpl" tabindex="0" class="mt-15">
              <div slot="header">
                <h3 class="card-title">360° VR 등록</h3>
                <ul>
                  <li>
                    360˚ 사진은 VR전용 카메라나 스마트폰 파노라마 촬영 기능을
                    활용하여 만드실 수 있습니다.
                  </li>
                  <li>
                    jpeg 이미지 확장자 형식의 파일로 1장만 등록이 가능합니다.
                  </li>
                  <li>
                    360˚ VR 사진을 여러장 등록하여 만드는 비대면 가상 VR 투어는
                    유료로 이용이 가능합니다.
                  </li>
                </ul>
              </div>
              <el-upload
                class="upload-demo col-12 px-0 text-center"
                drag
                :limit="3"
                :auto-upload="false"
                action="#"
                :on-change="Vr_UploadChange"
                :on-remove="Vr_RemoveFile"
                :on-exceed="exceedFileLimit"
                :file-list="Vr_Img_File.fileList"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  파일을 여기로 끌어 놓으세요. 혹은 <em>클릭해주세요.</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  사이즈 500kb 미만의 jpg/png 파일로 제한
                </div>
              </el-upload>
            </card>
          </div>

          <!-- ============================================ 기타 의견 -->
          <div class="">
            <card class="mt-15">
              <div slot="header">
                <h3 class="card-title">기타 의견</h3>
              </div>
              <el-input
                v-model="etcComment"
                type="textarea"
                :rows="4"
                placeholder="집비오에게 하고 싶은 말이 있으신가요? 여기에 남겨주세요."
              ></el-input>
            </card>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import openApi from "@/service/openapi";
import filestoreApi from "@/service/filestore";

import ServiceInfo from "@/pages/jipvio/GeneralViews/ServiceInfoForAgt.vue";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { createNamespacedHelpers } from "vuex";

extend("required", required);

import {
  Card,
  CheckboxGroup,
  Checkbox,
  Table,
  TableColumn,
  Button,
  RadioGroup,
  Radio,
  Message,
  Upload,
  Select,
  Option,
  Input,
  Loading,
  Tooltip,
  DatePicker,
} from "element-ui";

const {
  mapActions: sessionMapActions,
  mapGetters: sessionMapGetters,
} = createNamespacedHelpers("loginSession");

export default {
  components: {
    ServiceInfo,
    Card,
    [Button.name]: Button,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Message.name]: Message,
    [Upload.name]: Upload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Loading.name]: Loading,
    [Tooltip.name]: Tooltip,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      loading: false,
      //==================================
      propertyRAddr: null, //매물 도로명 주소
      propertyLat: null, // 매물 위도
      propertyLong: null, // 매물 경도

      locationInfo: {}, // 매물 주소 총정보
      fullRAddr: null, //매물 full도로명
      fullJAddr: null, //매물 full지번

      jipvioMarker: null,
      jipvioMap: null,
      jipvioGeocoder: null,

      dongDisable: false,
      hoDisable: false,

      allFloor: false,
      partFloor: false,
      partArea: null, // 직접입력한 면적
      hoTitle: null, // 직접입력한 호 명칭
      flrCheckShow: false, // 전체,일부 체크박스 Show 여부

      legalCode: null, //법정동 코드

      newBun: null, // for문으로 만든 bun
      newJi: null, // for문으로 만든 ji
      jiBun: null, // 지번 주소의 jiBun
      legalDong: null, //법정동

      brdList: [], // 용도지역 리스트

      //bdRegExposList: [], // 전유부 리스트
      genBdList: null, //총괄표제부
      bdList: [], //표제부 리스트
      selectedDongIdx: null, //선택된 동
      selectedBd: null, //해당 표제부

      hoList: [], //호 리스트
      selectedHo: null, // 선택된 호

      flrList: [], //층 리스트
      selectedFlr: null, //선택된 층수

      useArea: null, // 전용면적
      provArea: null, // 공급면적
      purpsDetail: null, // 주용도

      platGbCd: null, //대지구분코드

      //-------------------------------------step4에서 가져옴
      clsfData: [
        {
          clsfByJv: "아파트",
          purpsDetail: "아파트",
          purps: "공동주택",
        },
        {
          clsfByJv: "빌라",
          purpsDetail: "다세대, 연립",
          purps: "공동주택",
        },
        {
          clsfByJv: "주택",
          purpsDetail: "단독, 다중, 다가구",
          purps: "단독주택",
        },
        {
          clsfByJv: "오피스텔",
          purpsDetail: "업무시설(오피스텔)",
          purps: "업무시설",
        },
        {
          clsfByJv: "원룸",
          purpsDetail: "정의되어 있지 않음",
          purps: "정의되어 있지 않음",
        },
      ],
      selects: {
        BIO: [],
        PTT: [],
        PTTMap: {},
        ETT: [],
        HTT: [],
        HFT: [],
        MPM: [],
        USR: [],
        VPD: [],
        VPT: [],
        MTN: [],
        SCF: [],
        DRT: [],
        UUF: [],
        DST: [],
      },

      paymentType: null,
      deposit: null,
      monthlyPay: null,
      possibleMoveDate: null, // 입주가능일
      loanYn: null, //전세자금대출 가능여부
      imdMove: false, // 즉시입주(true, false)
      TNORooms: null, //방 수
      TNORoomsDirect: false, // 방 수 직접선택 체크박스
      TNOBathRooms: null, //욕실 수
      TNOBathRoomsDirect: null, //욕실 수 직접선택 체크박스,
      eleYn: null, // 승강기 여부
      heatingType: null, //난방방식
      heatingFuel: null, //난방연료
      entStructure: null, //현관구조
      directionStd: null, //방향 기준
      direction: null, //방향
      verandaYn: false, //베란다 체크박스
      balconyYn: false, // 발코니 체크박스
      parkingYn: null, // 주차가능여부
      PknPerFmly: null, // 가구당 주차가능대수
      maintenanceFee: null, //관리비
      maintenList: [], //선택된 관리비 포함항목
      useFeeYn: null, //사용료
      useFeeList: [], //사용료 포함내역

      optionYn: null, //옵션유무
      optionList: [], //선택된 옵션들
      securityYn: null,
      securityList: [], //선택된 보안시설
      petYn: null, //반려동물 가능여부
      possibleVisitDays: [], //방문 가능 요일
      possibleVisitTimes: [], //방문 가능 시간

      extrExpl: null, //추가설명
      oneHouseAgr: null, //단독주택일 경우 동의 체크박스
      shareHouseAgr: null, //공동주택일 경우 동의 체크박스

      G_Img_File: {
        data: null, // request body
        fileList: [],
        idArr: [],
        removedIdArr: [],
      },

      Vr_Img_File: {
        data: null, // request body
        fileList: [],
        idArr: [],
        removedIdArr: [],
      },

      etcComment: null, //기타 의견

      isEtv: false, // extraValidtation 에 걸렸는지
    };
  },
  created() {
    console.log("AgtStep3");
    this.bringData();
    this.applyCommonCode();
  },
  mounted() {
    if (window.kakao && window.kakao.maps) {
      this.initMap();
    } else {
      const script = document.createElement("script");
      /* global kakao */
      const serviceKey = process.env.VUE_APP_KKO_SDK_KEY;

      script.onload = () => kakao.maps.load(this.initMap);

      script.src = `https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${serviceKey}&libraries=services`;
      // <head></head>에 위치
      document.head.appendChild(script);
    }
  },

  watch: {
    async sessionTargetJuso(newValue, oldValue) {
      this.loading = true;

      this.locationInfo = newValue;
      this.propertyRAddr = this.locationInfo.roadFullAddr;

      if (
        this.locationInfo.lnbrSlno == null ||
        this.locationInfo.lnbrSlno == 0
      ) {
        this.jiBun = this.locationInfo.lnbrMnnm;
      } else {
        this.jiBun =
          this.locationInfo.lnbrMnnm + "-" + this.locationInfo.lnbrSlno;
      }

      this.legalDong = this.locationInfo.emdNm;
      this.changeMap();
      // 시군구 코드와 법정동 코드 -> 건축물대장

      this.bdList = null;
      this.hoList = null;
      this.flrList = null;
      this.selectedDongIdx = null;
      this.selectedHo = null;
      this.selectedFlr = null;
      this.dongDisable = false;
      this.hoDisable = false;
      this.allFloor = false;
      this.partFloor = false;
      this.partArea = null;
      this.flrCheckShow = false;

      this.getFullRAddress();
      this.getFullJAddress();

      // 번, 지
      let bun = newValue.lnbrMnnm;
      let ji = newValue.lnbrSlno;

      for (let i = 0; i < 4 - newValue.lnbrMnnm.length; i++) {
        bun = "0" + bun;
      }
      for (let i = 0; i < 4 - newValue.lnbrSlno.length; i++) {
        ji = "0" + ji;
      }
      this.newBun = bun;
      this.newJi = ji;

      // 표제부 / 총괄 표제부 / etc ...
      const propInfo = {
        sigunguCd: newValue.admCd.substring(0, 5),
        bjdongCd: newValue.admCd.substring(5, 10),
        bun: bun,
        ji: ji,
      };
      let res = await openApi.getPropInfo(propInfo);
      console.log(res);
      if (res.status != 200) {
        this.loading = false;
        Message({
          message: "다시 검색해주세요.",
          type: "error",
        });
        return;
      }

      if (res.payload.bdRegDistrictInfoList.length > 0) {
        res.payload.bdRegDistrictInfoList.forEach((brdl) => {
          this.brdList = [];
          if (
            brdl.etcJijigu == null ||
            brdl.etcJijigu == " " ||
            brdl.etcJijigu == ""
          ) {
            this.brdList.push(brdl.jijiguCdNm);
          } else {
            this.brdList.push(brdl.etcJijigu);
          }
        });
      } else {
        this.brdList = [];
      }

      //총괄표제부
      this.genBdList = res.payload.bdRegGenTitleList;

      // 표제부
      this.bdList = res.payload.bdRegTitleList;

      if (res.payload.bdRegGenTitleList.length == 0) {
        console.log("총괄표제부 없음");
        // 총괄표제부 없다는 것은 동이 존재하지 않음.
        this.dongDisable = true;

        propInfo.dongNm =
          this.bdList[0].dongNm === " " ? null : this.bdList[0].dongNm;

        res = await openApi.getAllPropHoFlr(propInfo);
        if (res.payload.hoList.length == 0) {
          this.hoDisable = true;
        }

        this.hoList = res.payload.hoList;
        this.flrList = res.payload.flrList;
        if (this.hoList.length == 0) {
          this.flrCheckShow = true;
        }
      }
      this.loading = false;
    },
  },

  computed: {
    ...sessionMapGetters({
      sessionCoCodeMap: "getCoCodeMap",
      sessionPropertyInquiry: "getPropertyInquiry",
      sessionTargetJuso: "getTargetJuso",
    }),

    fullAddr() {
      if (this.fullRAddr == null || this.fullJAddr == null) {
        return "도로명: " + "\n" + "지번:";
      } else {
        return "도로명: " + this.fullRAddr + "\n" + "지번:" + this.fullJAddr;
      }
    },

    modifiedDong() {
      if (
        this.selectedDongIdx != null &&
        this.bdList[this.selectedDongIdx].dongNm.charAt(
          this.bdList[this.selectedDongIdx].dongNm.length - 1
        ) == "동"
      ) {
        return this.bdList[this.selectedDongIdx].dongNm.slice(0, -1);
      } else if (this.selectedDongIdx != null) {
        return this.bdList[this.selectedDongIdx].dongNm;
      } else {
        return null;
      }
    },

    modifiedHo() {
      if (this.selectedHo.charAt(this.selectedHo.length - 1) == "호") {
        return this.selectedHo.slice(0, -1);
      } else {
        return this.selectedHo;
      }
    },

    modifiedFlr() {
      if (
        this.selectedFlr != null &&
        this.selectedFlr.charAt(this.selectedFlr.length - 1) == "층"
      ) {
        return this.selectedFlr.slice(0, -1);
      } else if (this.selectedFlr != null) {
        return this.selectedFlr;
      } else {
        return null;
      }
    },

    hhldCnt() {
      if (this.selectedBd != null) {
        if (this.selectedBd.hhldCnt != 0) {
          return this.selectedBd.hhldCnt;
        } else if (this.selectedBd.hoCnt != 0) {
          return this.selectedBd.hoCnt;
        } else {
          return null;
        }
      } else {
        null;
      }
    },

    strct() {
      if (this.selectedBd.etcStrct != null) {
        return this.selectedBd.etcStrct;
      } else {
        return this.selectedBd.strctCdNm;
      }
    },
    buildYear() {
      if (this.selectedBd != null) {
        if (
          this.selectedBd.useAprDay != null &&
          this.selectedBd.useAprDay != undefined &&
          this.selectedBd.useAprDay != " "
        ) {
          return this.selectedBd.useAprDay.substring(0, 4);
        } else {
          return null;
        }
      } else {
        return null;
      }
    },

    totArea() {
      if (this.selectedBd != null) {
        return parseFloat(this.selectedBd.totArea.toFixed(2));
      } else {
        return null;
      }
    },

    useAprDay() {
      if (this.selectedBd != null) {
        return this.selectedBd.useAprDay;
      } else {
        return null;
      }
    },

    modifiedUseAprDay() {
      if (this.selectedBd != null) {
        let UAD = this.selectedBd.useAprDay;
        if (UAD != null && UAD != undefined && UAD != " ") {
          return (
            UAD.substring(0, 4) +
            "-" +
            UAD.substring(4, 6) +
            "-" +
            UAD.substring(6, 8)
          );
        } else {
          return null;
        }
      } else {
        return null;
      }
    },

    dongNm() {
      if (this.selectedDongIdx == null) {
        return null;
      } else {
        return this.bdList[this.selectedDongIdx].dongNm;
      }
    },

    jpvTypeCd() {
      const purp = this.purpsDetail;
      if (purp.search("아파트") != -1) {
        return "APT";
      } else if (purp.search("다세대") != -1 || purp.search("연립") != -1) {
        return "VLL";
      } else if (
        purp.search("단독") != -1 ||
        purp.search("다중") != -1 ||
        purp.search("다가구") != -1
      ) {
        return "HOM";
      } else if (
        purp.search("오피스텔") != -1 ||
        purp.search("업무시설") != -1
      ) {
        return "OPS";
      } else {
        return null;
      }
    },

    platArea() {
      if (this.genBdList != null && this.selectedBd != null) {
        if (this.genBdList.length == 0) {
          return this.selectedBd.platArea;
        } else {
          return this.genBdList[0].platArea;
        }
      } else {
        return null;
      }
    },

    totPkngCnt() {
      if (this.genBdList != null && this.selectedBd != null) {
        if (this.genBdList.length == 0) {
          return (
            this.selectedBd.indrAutoUtcnt +
            this.selectedBd.indrMechUtcnt +
            this.selectedBd.oudrAutoUtcnt +
            this.selectedBd.oudrMechUtcnt
          );
        } else {
          return this.genBdList[0].totPkngCnt;
        }
      } else {
        return null;
      }
    },

    platGbCdNm() {
      if (this.platGbCd == 0) {
        return "대";
      } else if (this.platGbCd == 1) {
        return "산";
      } else if (this.platGbCd == 2) {
        return "블록";
      } else {
        return null;
      }
    }, // 대지구분이름(0: 대,1:산 2:블록 )

    brdListForInput() {
      if (this.brdList.length != 0) {
        let brdL = "";
        if (this.brdList.length == 1) {
          return this.brdList[0];
        } else {
          for (var i = 0; i < this.brdList.length - 1; i++) {
            brdL = brdL + this.brdList[i] + ",";
          }
          return brdL + this.brdList[this.brdList.length - 1];
        }
      } else {
        return null;
      }
    },

    purps() {
      if (this.purpsDetail != null) {
        const purp = this.purpsDetail;
        if (
          purp.search("아파트") != -1 ||
          purp.search("다세대") != -1 ||
          purp.search("연립") != -1
        ) {
          return "PBH";
        } else if (
          purp.search("단독") != -1 ||
          purp.search("다중") != -1 ||
          purp.search("다가구") != -1
        ) {
          return "SFH";
        } else if (
          purp.search("오피스텔") != -1 ||
          purp.search("업무시설") != -1
        ) {
          return "BSF";
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    modifiedPMD() {
      let PMD = this.possibleMoveDate;
      if (PMD != "0000-00-00") {
        PMD = this.$moment(PMD).format("YYYY-MM-DD");
        return PMD;
      } else {
        return PMD;
      }
    },

    finalProvArea() {
      if (this.partArea != 0 && this.partArea != null) {
        return this.partArea;
      } else if (this.provArea != null) {
        return parseFloat(this.provArea.toFixed(2));
      } else {
        return null;
      }
    },

    finalUseArea() {
      if (this.partArea != 0 && this.partArea != null) {
        return this.partArea;
      } else if (this.useArea != null) {
        return parseFloat(this.useArea.toFixed(2));
      } else {
        return null;
      }
    },

    supplyAreaP() {
      return Math.round(this.finalProvArea * 0.3025);
    },

    useAreaP() {
      return Math.round(this.finalUseArea * 0.3025);
    },

    totFlrCnt() {
      if (this.selectedBd != null) {
        return this.selectedBd.grndFlrCnt;
      } else {
        return null;
      }
    },
    isOnlyRoom() {
      if (this.TNORooms == 1) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    ...sessionMapActions(["saveAgtPropertyInquiryStep3"]),

    bringData() {
      this.propertyRAddr = this.sessionPropertyInquiry.propertyInfo.propertyRAddr; //매물 도로명 주소
      this.propertyLat = this.sessionPropertyInquiry.propertyInfo.propertyLat; // 매물 위도
      this.propertyLong = this.sessionPropertyInquiry.propertyInfo.propertyLong; // 매물 경도

      this.locationInfo = this.sessionPropertyInquiry.propertyInfo.locationInfo; // 매물 주소 총정보
      this.fullRAddr = this.sessionPropertyInquiry.propertyInfo.fullRAddr; //매물 full도로명
      this.fullJAddr = this.sessionPropertyInquiry.propertyInfo.fullJAddr; //매물 full지번

      this.dongDisable = this.sessionPropertyInquiry.propertyInfo.dongDisable;
      this.hoDisable = this.sessionPropertyInquiry.propertyInfo.hoDisable;

      this.allFloor = this.sessionPropertyInquiry.propertyInfo.allFloor;
      this.partFloor = this.sessionPropertyInquiry.propertyInfo.partFloor;
      this.partArea = this.sessionPropertyInquiry.propertyInfo.partArea; // 직접입력한 면적
      this.hoTitle = this.sessionPropertyInquiry.propertyInfo.hoTitle; // 직접입력한 호 명칭
      this.flrCheckShow = this.sessionPropertyInquiry.propertyInfo.flrCheckShow; // 전체,일부 체크박스 Show 여부

      this.legalCode = this.sessionPropertyInquiry.propertyInfo.legalCode; //법정동 코드

      this.newBun = this.sessionPropertyInquiry.propertyInfo.newBun; // for문으로 만든 bun
      this.newJi = this.sessionPropertyInquiry.propertyInfo.newJi; // for문으로 만든 ji
      this.jiBun = this.sessionPropertyInquiry.propertyInfo.newJi; // 지번주소의 지번
      this.legalDong = this.sessionPropertyInquiry.propertyInfo.legalDong; // 법정동

      this.brdList = this.sessionPropertyInquiry.propertyInfo.rawBrdList; // 용도지역 리스트

      this.genBdList = this.sessionPropertyInquiry.propertyInfo.genBdList; //총괄표제부
      this.bdList = this.sessionPropertyInquiry.propertyInfo.bdList; //표제부 리스트
      this.selectedDongIdx = this.sessionPropertyInquiry.propertyInfo.selectedDongIdx; //선택된 동
      this.selectedBd = this.sessionPropertyInquiry.propertyInfo.selectedBd; //해당 표제부

      this.hoList = this.sessionPropertyInquiry.propertyInfo.hoList; //호 리스트
      this.selectedHo = this.sessionPropertyInquiry.propertyInfo.AddrHo; // 선택된 호

      this.flrList = this.sessionPropertyInquiry.propertyInfo.flrList; //층 리스트
      this.selectedFlr = this.sessionPropertyInquiry.propertyInfo.AddrFloor; //선택된 층수

      this.useArea = this.sessionPropertyInquiry.propertyInfo.useArea; // 전용면적
      this.provArea = this.sessionPropertyInquiry.propertyInfo.provArea; // 공급면적
      this.purpsDetail = this.sessionPropertyInquiry.propertyInfo.purpsDetail; // 주용도

      this.platGbCd = this.sessionPropertyInquiry.propertyInfo.platGbCd; //대지구분코드

      //-------------------------------------------------------------------------

      this.paymentType = this.sessionPropertyInquiry.propertyInfo.rawCTT;
      this.deposit = this.sessionPropertyInquiry.propertyInfo.deposit;
      this.monthlyPay = this.sessionPropertyInquiry.propertyInfo.monthlyPay;
      this.possibleMoveDate = this.sessionPropertyInquiry.propertyInfo.pmdNotMdf; // 입주가능일
      this.imdMove = this.sessionPropertyInquiry.propertyInfo.imdMove; // 즉시입주(true, false)
      this.loanYn = Number(
        this.sessionPropertyInquiry.propertyInfo.loanYn
      ).toString(); //전세자금대출 가능여부

      this.TNORooms = this.sessionPropertyInquiry.propertyInfo.TNORooms; //방 수
      this.TNORoomsDirect = this.sessionPropertyInquiry.propertyInfo.TNORoomsDirect; // 방 수 직접선택 체크박스
      this.TNOBathRooms = this.sessionPropertyInquiry.propertyInfo.TNOBathRooms; //욕실 수
      this.TNOBathRoomsDirect = this.sessionPropertyInquiry.propertyInfo.TNOBathRoomsDirect; //욕실 수 직접선택 체크박스
      this.eleYn = Number(
        this.sessionPropertyInquiry.propertyInfo.eleYn
      ).toString(); // 승강기 여부
      this.heatingType = this.sessionPropertyInquiry.propertyInfo.heatingType; //난방방식
      this.heatingFuel = this.sessionPropertyInquiry.propertyInfo.heatingFuel; //난방연료
      this.entStructure = this.sessionPropertyInquiry.propertyInfo.entStructure; //현관구조
      this.directionStd = this.sessionPropertyInquiry.propertyInfo.directionStd; //방향 기준
      this.direction = this.sessionPropertyInquiry.propertyInfo.direction; //방향
      this.verandaYn = this.sessionPropertyInquiry.propertyInfo.verandaYn; //베란다 체크박스
      this.balconyYn = this.sessionPropertyInquiry.propertyInfo.balconyYn; // 발코니 체크박스
      this.parkingYn = Number(
        this.sessionPropertyInquiry.propertyInfo.parkingYn
      ).toString(); // 주차가능여부
      this.PknPerFmly = this.sessionPropertyInquiry.propertyInfo.PknPerFmly; // 가구당 주차가능대수
      this.maintenanceFee = this.sessionPropertyInquiry.propertyInfo.maintenanceFee; //관리비
      this.maintenList = this.sessionPropertyInquiry.propertyInfo.maintenList; //선택된 관리비 포함항목
      this.useFeeYn = Number(
        this.sessionPropertyInquiry.propertyInfo.useFeeYn
      ).toString(); //사용료 유무
      this.useFeeList = this.sessionPropertyInquiry.propertyInfo.maintenList; //사용료 포함내역

      this.optionYn = Number(
        this.sessionPropertyInquiry.propertyInfo.optionYn
      ).toString(); //옵션유무
      this.optionList = this.sessionPropertyInquiry.propertyInfo.optionList; //선택된 옵션들
      this.securityYn = Number(
        this.sessionPropertyInquiry.propertyInfo.securityYn
      ).toString();
      this.securityList = this.sessionPropertyInquiry.propertyInfo.securityList; //선택된 보안시설
      this.petYn = Number(
        this.sessionPropertyInquiry.propertyInfo.petYn
      ).toString(); //반려동물 가능여부
      this.possibleVisitDays = this.sessionPropertyInquiry.propertyInfo.possibleVisitDays; //방문 가능 요일
      this.possibleVisitTimes = this.sessionPropertyInquiry.propertyInfo.possibleVisitTimes; //방문 가능 시간

      this.extrExpl = this.sessionPropertyInquiry.propertyInfo.extrExpl; //추가설명

      this.oneHouseAgr = this.sessionPropertyInquiry.propertyInfo.oneHouseAgr; //단독주택일 경우 동의 체크박스
      this.shareHouseAgr = this.sessionPropertyInquiry.propertyInfo.shareHouseAgr; //공동주택일 경우 동의 체크박스

      this.G_Img_File = this.sessionPropertyInquiry.propertyInfo.G_Img_File; //일반 이미지 파일
      this.Vr_Img_File = this.sessionPropertyInquiry.propertyInfo.Vr_Img_File; //vr이미지 파일
      this.etcComment = this.sessionPropertyInquiry.propertyInfo.etcComment; //기타 의견
    },

    saveStep() {
      this.saveStep3Info();
    },

    saveStep3Info() {
      console.log("Agt step3 Action!");
      const propertyInfo = {
        propertyJAddr: this.locationInfo.jibunAddr, //건물 지번 주소
        propertyRAddr: this.propertyRAddr, //건물 도로명 주소
        propertyLat: this.propertyLat, //매물 위도
        propertyLong: this.propertyLong, //매물 경도

        selectedDongIdx: this.selectedDongIdx,
        AddrDong: this.dongNm, //동
        AddrHo: this.selectedHo, //호
        AddrFloor: this.selectedFlr, //층
        flrJustNum: this.modifiedFlr, // 층 숫자만
        hoJustNm: this.modifiedHo, // 호 이름만
        dongJustNm: this.modifiedDong, // 동 이름만

        locationInfo: this.locationInfo, // 매물 주소 총정보
        fullRAddr: this.fullRAddr, //주소+동호층 (도로명)
        fullJAddr: this.fullJAddr, //주소+동호층 (지번)

        dongDisable: this.dongDisable,
        hoDisable: this.hoDisable,

        allFloor: this.allFloor, // 층 전체 체크박스
        partFloor: this.partFloor, //층 일부 체크박스
        partArea: parseFloat(Number(this.partArea).toFixed(2)), // 층 일부 직접 입력한 면적  --일반 step4에 없음
        hoTitle: this.hoTitle, // 직접입력한 호 명칭
        flrCheckShow: this.flrCheckShow, // 층 관련 체크박스 show 여부  --일반 step4에 없음

        legalCode: this.locationInfo.admCd, //법정동 코드  --일반 step4에 없음

        newBun: this.newBun, // for문으로 만든 bun
        newJi: this.newJi, // for문으로 만든 ji
        jiBun: this.jiBun, // 지번주소의 지번
        legalDong: this.legalDong, // 법정동

        genBdList: this.genBdList, //총괄표제부
        bdList: this.bdList, // 표제부 리스트
        selectedBd: this.selectedBd, //해당 표제부

        hoList: this.hoList, //호 리스트
        flrList: this.flrList, // 층 리스트

        //=============================================
        strct: this.strct, // 건축물 구조
        rawBrdList: this.brdList, // 용도지역 원본 리스트 (ex)['일반주거지역', '공업지역'])
        brdList: this.brdListForInput, // 용도지역 String (ex) 일반주거지역, 공업지역)
        purps: this.purps, //건축물 용도 (건축법)
        purpsDetail: this.purpsDetail, // 건축물 세부용도(api)
        jpvTypeCd: this.jpvTypeCd, //아파트, 빌라, 주택, 오피스텔
        isOnlyRoom: this.isOnlyRoom, //원룸 여부
        platArea: this.platArea, // 대지면적
        totArea: this.totArea, // 연면적
        hhldCnt: this.hhldCnt, // 총 세대수
        bdNm: this.locationInfo.bdNm, //건물명
        permitDate: this.modifiedUseAprDay, //사용승인 일자
        totPkngCnt: this.totPkngCnt, //총 주차대수
        platGbCd: this.platGbCd, // 대지구분코드

        rawCTT: this.paymentType, // 단순한 월세 전세 string값(데이터 유지 용도)
        paymentType: this.selects.PTTMap[this.paymentType], //거래유형
        deposit: Number(this.deposit) * 10000, //보증금
        monthlyPay: Number(this.monthlyPay) * 10000, //월세
        pmdNotMdf: this.possibleMoveDate, // 포맷 수정 안된 입주가능일(불러오기 용도)
        possibleMoveDate: this.modifiedPMD, // formmat 수정 된 입주가능일
        imdMove: this.imdMove, // 즉시입주(true, false)
        loanYn: Boolean(Number(this.loanYn)), //전세자금대출 가능여부

        provArea: this.finalProvArea, // 공급면적
        useArea: this.finalUseArea, //전용면적
        grndFlrCnt: this.totFlrCnt, //총 층
        TNORooms: Number(this.TNORooms), //방 수
        TNORoomsDirect: this.TNORoomsDirect, //방개수 직접입력인지 아닌지
        TNOBathRooms: Number(this.TNOBathRooms), //욕실 수
        TNOBathRoomsDirect: this.TNOBathRoomsDirect, //욕실개수 직접입력인지 아닌지
        eleYn: Boolean(Number(this.eleYn)), // 승강기 여부
        heatingType: this.heatingType, //난방방식
        heatingFuel: this.heatingFuel, //난방연료
        entStructure: this.entStructure, //현관구조
        directionStd: this.directionStd, //방향 기준
        direction: this.direction, //방향
        verandaYn: this.verandaYn, //베란다 체크박스
        balconyYn: this.balconyYn, // 발코니 체크박스
        parkingYn: Boolean(Number(this.parkingYn)), // 주차가능여부
        PknPerFmly: Number(this.PknPerFmly), // 가구당 주차가능대수
        maintenanceFee: Number(this.maintenanceFee) * 10000, //관리비
        maintenList: this.maintenList, //선택된 관리비 포함항목
        useFeeYn: Boolean(Number(this.useFeeYn)), //사용료
        useFeeList: this.useFeeList, //선택된 사용료 포함항목

        optionYn: Boolean(Number(this.optionYn)), //옵션 유무
        optionList: this.optionList, //선택된 옵션들
        securityYn: Boolean(Number(this.securityYn)), //보안시설 유무
        securityList: this.securityList, //선택된 보안시설
        petYn: Boolean(Number(this.petYn)), // 반려동물 가능여부
        possibleVisitDays: this.possibleVisitDays, //방문 가능 요일
        possibleVisitTimes: this.possibleVisitTimes, //방문 가능 시간

        extrExpl: this.extrExpl, //매물 추가 설명

        oneHouseAgr: this.oneHouseAgr, // 추가정보 동의 YN (단독주택 경우)
        shareHouseAgr: this.shareHouseAgr, // 추가정보 동의 YN (공동주택 경우)

        G_Img_File: this.G_Img_File, //일반 이미지 파일
        Vr_Img_File: this.Vr_Img_File, //vr이미지 파일

        etcComment: this.etcComment, //기타 의견
      };
      this.saveAgtPropertyInquiryStep3(propertyInfo);
      console.log(this.sessionPropertyInquiry);
    },

    async showMessage() {
      let errMsg = [];

      let res = await this.$refs["propertyRAddrVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "매물 주소를 검색해주세요.",
          focusId: "agt_step3_propLocInfoCard",
        });
      }

      res = await this.$refs["selectedFlrVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "층을 선택해주세요.",
          focusId: "agt_step3_propLocInfoCard",
        });
      }

      res = await this.$refs["ctrTypeVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "거래유형을 선택해주세요.",
          focusId: "agt_step3_contrInfoCard",
        });
      }

      res = await this.$refs["depositVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "보증금을 입력해주세요.",
          focusId: "agt_step3_contrInfoCard",
        });
      }

      if (this.selects.PTTMap[this.paymentType] === "MP") {
        res = await this.$refs["monthlyPayVal"].validate();
        if (!res.valid) {
          errMsg.push({
            message: "월세을 입력해주세요.",
            focusId: "agt_step3_contrInfoCard",
          });
        }
      }

      res = await this.$refs["possibleMoveDateVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "입주 가능일을 확인해주세요.",
          focusId: "agt_step3_contrInfoCard",
        });
      }

      res = await this.$refs["loanYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "전세자금대출 가능여부를 확인해주세요.",
          focusId: "agt_step3_contrInfoCard",
        });
      }

      res = await this.$refs["TNORoomsVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "방 수를 확인해주세요.",
          focusId: "agt_step3_detailInfoCard",
        });
      }

      res = await this.$refs["TNOBathRoomsVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "욕실 수를 확인해주세요.",
          focusId: "agt_step3_detailInfoCard",
        });
      }

      res = await this.$refs["eleYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "승강기 유무를 확인해주세요.",
          focusId: "agt_step3_detailInfoCard",
        });
      }

      res = await this.$refs["heatingTypeVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "난방방식을 확인해주세요.",
          focusId: "agt_step3_detailInfoCard",
        });
      }

      res = await this.$refs["heatingFuelVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "난방연료를 확인해주세요.",
          focusId: "agt_step3_detailInfoCard",
        });
      }

      res = await this.$refs["entStructureVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "현관구조를 확인해주세요.",
          focusId: "agt_step3_detailInfoCard",
        });
      }

      res = await this.$refs["directionStdVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "방향 기준을 확인해주세요.",
          focusId: "agt_step3_detailInfoCard",
        });
      }

      res = await this.$refs["directionVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "방향을 확인해주세요.",
          focusId: "agt_step3_detailInfoCard",
        });
      }

      res = await this.$refs["parkingYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "주차가능대수를 확인해주세요.",
          focusId: "agt_step3_detailInfoCard",
        });
      }

      if (Number(this.parkingYn) === 1) {
        res = await this.$refs["pknPerFmlyVal"].validate();
        if (!res.valid) {
          errMsg.push({
            message: "가구 당 주차대수를 입력해주세요.",
            focusId: "agt_step3_detailInfoCard",
          });
        }
      }

      res = await this.$refs["maintenanceFeeVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "관리비를 확인해주세요.",
          focusId: "agt_step3_detailInfoCard",
        });
      }

      res = await this.$refs["useFeeYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "사용료를 확인해주세요.",
          focusId: "agt_step3_detailInfoCard",
        });
      }

      if (Number(this.useFeeYn) === 1) {
        res = await this.$refs["useFeeListSelectVal"].validate();
        if (!res.valid) {
          errMsg.push({
            message: "사용료 항목을 선택해주세요.",
            focusId: "agt_step3_detailInfoCard",
          });
        }
      }

      res = await this.$refs["optionYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "옵션을 확인해주세요.",
          focusId: "agt_step3_extraInfoCard",
        });
      }

      if (Number(this.optionYn) === 1) {
        res = await this.$refs["optionListSelectVal"].validate();
        if (!res.valid) {
          errMsg.push({
            message: "옵션 항목을 선택해주세요.",
            focusId: "agt_step3_extraInfoCard",
          });
        }
      }

      res = await this.$refs["securityYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "보안시설을 확인해주세요.",
          focusId: "agt_step3_extraInfoCard",
        });
      }

      if (Number(this.securityYn) === 1) {
        res = await this.$refs["securityListSelectVal"].validate();
        if (!res.valid) {
          errMsg.push({
            message: "보안시설 항목을 선택해주세요.",
            focusId: "agt_step3_extraInfoCard",
          });
        }
      }

      res = await this.$refs["petYnVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "반려동물 가능여부를 확인해주세요.",
          focusId: "agt_step3_extraInfoCard",
        });
      }

      res = await this.$refs["possibleVisitDaysVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "방문 가능 요일을 확인해주세요.",
          focusId: "agt_step3_extraInfoCard",
        });
      }

      res = await this.$refs["possibleVisitTimesVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "방문 가능 시간을 확인해주세요.",
          focusId: "agt_step3_extraInfoCard",
        });
      }

      if (errMsg[0] != null) {
        document.getElementById(errMsg[0].focusId).focus();
        Message({
          message: errMsg[0].message,
          type: "error",
        });
      }

      if (errMsg[1] != null) {
        Message({
          message: errMsg[1].message,
          type: "error",
          offset: 60,
        });
      }

      if (errMsg[2] != null) {
        Message({
          message: errMsg[2].message,
          type: "error",
          offset: 100,
        });
      }
    },

    extraValidate() {
      this.isEtv = false;
      let errMsg = [];

      if (this.bdList.length > 1 && this.selectedDongIdx == null) {
        errMsg.push({
          message: "동를 선택해주세요",
          focusId: "agt_step3_propLocInfoCard",
        });
      }

      if (this.hoList.length > 0 && this.selectedHo == null) {
        errMsg.push({
          message: "호를 선택해주세요",
          focusId: "agt_step3_propLocInfoCard",
        });
      }

      if (
        this.flrCheckShow == true &&
        this.allFloor == false &&
        this.partFloor == false
      ) {
        errMsg.push({
          message: "전체 또는 일부를 선택해주세요",
          focusId: "agt_step3_propLocInfoCard",
        });
      }

      if (
        this.partFloor == true &&
        (this.partArea == null || this.partArea == "")
      ) {
        errMsg.push({
          message: "면적을 입력해주세요",
          focusId: "agt_step3_propLocInfoCard",
        });
      }

      if (
        this.partFloor == true &&
        (this.hoTitle == null || this.hoTitle == "")
      ) {
        errMsg.push({
          message: "명칭을 입력해주세요",
          focusId: "agt_step3_propLocInfoCard",
        });
      }

      if (
        this.maintenanceFee != null &&
        this.maintenanceFee != 0 &&
        this.maintenList.length == 0
      ) {
        errMsg.push({
          message: "관리비 항목을 선택해주세요.",
          focusId: "agt_step3_detailInfoCard",
        });
      }

      if (this.G_Img_File.fileList.length < 1) {
        errMsg.push({
          message: " 사진을 등록해주세요.",
          focusId: "agt_step3_GImgUpl",
        });
      }

      if (
        this.G_Img_File.fileList.length > 0 &&
        this.G_Img_File.fileList
          .map((file) => file.size)
          .reduce((acc, curr) => acc + curr) >
          100 * 1000 * 1000
      ) {
        errMsg.push({
          message: " 일반 사진 전체 크키는 100MB를 초과할 수 없습니다.",
          focusId: "agt_step3_VrImgUpl",
        });
      }

      // if (this.Vr_Img_File.fileList.length < 1) {
      //   errMsg.push({
      //     message: "VR 사진을 등록해주세요.",
      //     focusId: "agt_step3_GImgUpl"
      //   });
      // }

      if (
        this.Vr_Img_File.fileList.length > 0 &&
        this.Vr_Img_File.fileList
          .map((file) => file.size)
          .reduce((acc, curr) => acc + curr) >
          100 * 1000 * 1000
      ) {
        errMsg.push({
          message: " VR 사진 전체 크키는 100MB를 초과할 수 없습니다.",
          focusId: "agt_step3_VrImgUpl",
        });
      }

      if (errMsg[0] != null) {
        this.isEtv = true;

        document.getElementById(errMsg[0].focusId).focus();
        // document.getElementById(errMsg[0].focusId).scrollIntoView();
        Message({
          message: errMsg[0].message,
          type: "error",
        });
      }

      if (errMsg[1] != null) {
        Message({
          message: errMsg[1].message,
          type: "error",
          offset: 60,
        });
      }

      if (errMsg[2] != null) {
        Message({
          message: errMsg[2].message,
          type: "error",
          offset: 100,
        });
      }
    },

    validate() {
      return this.$refs.form.validate().then((res) => {
        if (!res) {
          this.showMessage();
          return;
        }

        this.extraValidate();
        if (this.isEtv) {
          return;
        }

        this.saveStep3Info();
        this.$emit("on-validated", res);
        return res;
      });
    },

    async getExtraInfo() {
      this.loading = true;
      const propInfo = {
        sigunguCd: this.locationInfo.admCd.substring(0, 5),
        bjdongCd: this.locationInfo.admCd.substring(5, 10),
        bun: this.newBun,
        ji: this.newJi,
        dongNm: this.dongNm,
        hoNm: this.selectedHo,
        floor: this.selectedFlr,
      };

      const res = await openApi.getPropDetailInfo(propInfo);

      if (res.status != 200) {
        this.loading = false;
        Message({
          message: "다시 시도해주세요.",
          type: "error",
        });
        return;
      }

      this.useArea = res.payload.useArea;
      this.provArea = res.payload.provArea;

      if (res.payload.mainPurpsCdNm != null) {
        this.purpsDetail = res.payload.mainPurpsCdNm;
      } else {
        this.purpsDetail = res.payload.etcPurps;
      }

      if (this.selectedDongIdx == null) {
        this.selectedBd = this.bdList[0];
      } else {
        this.selectedBd = this.bdList[this.selectedDongIdx];
      }
      this.platGbCd = Number(this.selectedBd.platGbCd);

      this.loading = false;
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    addressPop() {
      var pop = window.open(
        "./extension/juso.html",
        "pop_basic",
        "width=450,height=550,scrollbars=yes,resizable=yes"
      );
    },

    applyCommonCode() {
      console.log(this.sessionCoCodeMap);
      //BIO========================================================
      this.sessionCoCodeMap.BIO.forEach((ele, dex) => {
        this.selects.BIO.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //PTT========================================================
      this.sessionCoCodeMap.PTT.forEach((ele, dex) => {
        this.selects.PTT.push({
          value: ele.code,
          label: ele.name,
        });
        this.selects.PTTMap[ele.name] = ele.code;
      });

      //ETT========================================================
      this.sessionCoCodeMap.ETT.forEach((ele, dex) => {
        this.selects.ETT.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //HTT========================================================
      this.sessionCoCodeMap.HTT.forEach((ele, dex) => {
        this.selects.HTT.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //HFT========================================================
      this.sessionCoCodeMap.HFT.forEach((ele, dex) => {
        this.selects.HFT.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //MPM========================================================
      this.sessionCoCodeMap.MPM.forEach((ele, dex) => {
        this.selects.MPM.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //USR========================================================
      this.sessionCoCodeMap.USR.forEach((ele, dex) => {
        this.selects.USR.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //VPD========================================================
      this.sessionCoCodeMap.VPD.forEach((ele, dex) => {
        this.selects.VPD.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //VPT========================================================
      this.sessionCoCodeMap.VPT.forEach((ele, dex) => {
        this.selects.VPT.push({
          value: ele.code,
          label: ele.name,
        });
      });
      //MTN========================================================
      this.sessionCoCodeMap.MTN.forEach((ele, dex) => {
        this.selects.MTN.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //SCF========================================================
      this.sessionCoCodeMap.SCF.forEach((ele, dex) => {
        this.selects.SCF.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //DRT========================================================
      this.sessionCoCodeMap.DRT.forEach((ele, dex) => {
        this.selects.DRT.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //UUF========================================================
      this.sessionCoCodeMap.UUF.forEach((ele, dex) => {
        this.selects.UUF.push({
          value: ele.code,
          label: ele.name,
        });
      });

      //DST========================================================
      this.sessionCoCodeMap.DST.forEach((ele, dex) => {
        this.selects.DST.push({
          value: ele.code,
          label: ele.name,
        });
      });
    },

    initMap() {
      var self = this;

      const container = document.getElementById("AgtStep3Map");
      var options = {
        // required : 위도(latitude), 경도(longitude)
        center: new kakao.maps.LatLng(33.450705, 126.570677),
        level: 3,
      };

      this.jipvioMap = new kakao.maps.Map(container, options);
      this.jipvioGeocoder = new kakao.maps.services.Geocoder();

      // 마커를 생성합니다
      var marker = new kakao.maps.Marker({
        position: new kakao.maps.LatLng(33.450705, 126.570677), // 마커를 표시할 위치
        title: "카카오", // 마커의 타이틀, 마커에 마우스를 올리면 타이틀이 표시됩니다
      });
      self.jipvioMarker = marker;
      self.jipvioMarker.setMap(this.jipvioMap);

      if (this.propertyLat !== null || this.propertyLong !== null) {
        this.changeMap();
      }
    },
    changeMap() {
      const self = this;

      //마크 지우기
      self.jipvioMarker.setMap(null);
      self.jipvioMarker = null;

      this.jipvioGeocoder.addressSearch(
        this.locationInfo.roadFullAddr,
        function (result, status) {
          if (status === kakao.maps.services.Status.OK) {
            self.propertyLat = result[0].y;
            self.propertyLong = result[0].x;
            var coords = new kakao.maps.LatLng(result[0].y, result[0].x);

            //마커 생성
            var marker = new kakao.maps.Marker({
              position: coords,
            });

            self.jipvioMarker = marker;
            self.jipvioMarker.setMap(self.jipvioMap);

            //센터 이동
            self.jipvioMap.setCenter(coords);
          }
        }
      );
    },

    getFullRAddress() {
      if (this.locationInfo.roadFullAddr == null) {
        this.fullRAddr = null;
      } else if (this.selectedDongIdx == null) {
        if (this.selectedHo == null) {
          if (this.selectedFlr == null || this.selectedFlr == "") {
            this.fullRAddr = this.locationInfo.roadFullAddr;
          } else {
            this.fullRAddr =
              this.locationInfo.roadFullAddr + " " + this.modifiedFlr + "층";
          }
        } else if (this.selectedHo != null) {
          this.fullRAddr =
            this.locationInfo.roadFullAddr + " " + this.modifiedHo + "호";
        }
      } else if (
        this.bdList[this.selectedDongIdx].dongNm != null ||
        this.bdList[this.selectedDongIdx].dongNm != ""
      ) {
        if (this.selectedHo == null) {
          if (this.selectedFlr == null || this.selectedFlr == "") {
            this.fullRAddr =
              this.locationInfo.roadFullAddr + " " + this.modifiedDong + "동 ";
          } else {
            this.fullRAddr =
              this.locationInfo.roadFullAddr +
              " " +
              this.modifiedDong +
              "동 " +
              this.modifiedFlr +
              "층";
          }
        } else if (this.selectedHo != null) {
          this.fullRAddr =
            this.locationInfo.roadFullAddr +
            " " +
            this.modifiedDong +
            "동 " +
            this.modifiedHo +
            "호";
        }
      }
    },

    getFullJAddress() {
      if (this.locationInfo.jibunAddr == null) {
        this.fullJAddr = null;
      } else if (this.selectedDongIdx == null) {
        if (this.selectedHo == null) {
          if (this.selectedFlr == null || this.selectedFlr == "") {
            this.fullJAddr = this.locationInfo.jibunAddr;
          } else {
            this.fullJAddr =
              this.locationInfo.jibunAddr + " " + this.modifiedFlr + "층";
          }
        } else if (this.selectedHo != null) {
          this.fullJAddr =
            this.locationInfo.jibunAddr + " " + this.modifiedHo + "호";
        }
      } else if (
        this.bdList[this.selectedDongIdx].dongNm != null ||
        this.bdList[this.selectedDongIdx].dongNm != ""
      ) {
        if (this.selectedHo == null) {
          if (this.selectedFlr == null || this.selectedFlr == "") {
            this.fullJAddr =
              this.locationInfo.jibunAddr + " " + this.modifiedDong + "동 ";
          } else {
            this.fullJAddr =
              this.locationInfo.jibunAddr +
              " " +
              this.modifiedDong +
              "동 " +
              this.modifiedFlr +
              "층";
          }
        } else if (this.selectedHo != null) {
          this.fullJAddr =
            this.locationInfo.jibunAddr +
            " " +
            this.modifiedDong +
            "동 " +
            this.modifiedHo +
            "호";
        }
      }
    },

    async bringHoFlr() {
      this.loading = true;
      this.hoDisable = false;
      this.selectedHo = null;
      this.selectedFlr = null;
      this.hoList = [];
      this.flrList = [];

      this.getFullRAddress();
      this.getFullJAddress();

      const propInfo = {
        sigunguCd: this.locationInfo.admCd.substring(0, 5),
        bjdongCd: this.locationInfo.admCd.substring(5, 10),
        bun: this.newBun,
        ji: this.newJi,
        dongNm: this.bdList[this.selectedDongIdx].dongNm,
      };

      const res = await openApi.getAllPropHoFlr(propInfo);

      if (res.status != 200) {
        this.loading = false;
        Message({
          message: "다시 시도해주세요.",
          type: "error",
        });
        return;
      }

      if (res.payload.hoList.length == 0) {
        this.hoDisable = true;
      }
      this.flrList = res.payload.flrList;
      this.hoList = res.payload.hoList;

      this.loading = false;
    },

    changeDong(val) {
      return val.charAt(val.length - 1) === "동" ? val : `${val}동`;
    },

    changeHo(val) {
      return val.charAt(val.length - 1) === "호" ? val : `${val}호`;
    },

    changeFlr(val) {
      return val.charAt(val.length - 1) === "층" ? val : `${val}층`;
    },

    delPMD() {
      if (this.imdMove == true) {
        this.possibleMoveDate = "0000-00-00";
      } else {
        this.possibleMoveDate = null;
      }
    },

    TNORoomsDirectWrite() {
      if (this.TNORooms == "null") {
        this.TNORooms = null;
        this.TNORoomsDirect = true;
      } else {
        this.TNORoomsDirect = false;
      }
    },

    TNOBathRoomsDirectWrite() {
      if (this.TNOBathRooms == "null") {
        this.TNOBathRooms = null;
        this.TNOBathRoomsDirect = true;
      } else {
        this.TNOBathRoomsDirect = false;
      }
    },

    //======================================== 파일 업로드 메소드들

    // 파일첨부시(업로드x) 이벤트
    G_UploadChange: function (file, fileList) {
      console.log("fileList: ", fileList);
      this.G_Img_File.fileList = fileList;
      this.G_Img_File.fileList.forEach((file) => {
        if (file.size > 50 * 1000 * 1000) {
          Message.error("50MB이상 파일은 업로드할 수 없습니다.");
          this.G_Img_File.fileList.splice(
            this.G_Img_File.fileList.indexOf(file),
            1
          );
          return;
        }
      });
    },
    // 선택한 파일 삭제
    G_RemoveFile: function (file, fileList) {
      this.G_Img_File.fileList = fileList;
      // 삭제하는 파일의 raw 객체가 없다면, 그것은 이미 db에 존재하는 파일임. 이파일들의 id를 따로 모아서 파일삭제 api호출할 때 data로 집어넣음.
      console.log(file);
      if (file.raw === undefined) this.G_Img_File.removedIdArr.push(file.id); // DB에 존재하는 파일은 id가 존재함.
    },

    // 파일첨부시(업로드x) 이벤트
    Vr_UploadChange: function (file, fileList) {
      console.log("fileList: ", fileList);
      this.Vr_Img_File.fileList = fileList;
      this.Vr_Img_File.fileList.forEach((file) => {
        if (file.size > 50 * 1000 * 1000) {
          Message.error("50MB이상 파일은 업로드할 수 없습니다.");
          this.Vr_Img_File.fileList.splice(
            this.Vr_Img_File.fileList.indexOf(file),
            1
          );
          return;
        }
      });
    },
    // 선택한 파일 삭제
    Vr_RemoveFile: function (file, fileList) {
      this.Vr_Img_File.fileList = fileList;
      // 삭제하는 파일의 raw 객체가 없다면, 그것은 이미 db에 존재하는 파일임. 이파일들의 id를 따로 모아서 파일삭제 api호출할 때 data로 집어넣음.
      console.log(file);
      if (file.raw === undefined) this.Vr_Img_File.removedIdArr.push(file.id); // DB에 존재하는 파일은 id가 존재함.
    },

    // 지정한 파일갯수를 초과해서 첨부했을 때
    exceedFileLimit: function () {
      Message.warning("파일첨부는 1개만 가능합니다.");
    },
  },
};
</script>
<style></style>
